import { ArrowLeft, Edit2, Package, Building2, DollarSign } from 'lucide-react';

export const ProductDetailsView = ({ product, company, onBack, onEdit }) => {
    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(amount);
    };

    return (
        <div className="space-y-6">
            {/* Header */}
            <div className="flex items-center gap-4">
                <button
                    onClick={onBack}
                    className="p-2 hover:bg-gray-100 rounded-lg transition"
                >
                    <ArrowLeft className="w-5 h-5" />
                </button>
                <h2 className="text-2xl font-semibold text-gray-900">Product Details</h2>
            </div>

            {/* Product Info Card */}
            <div className="bg-white rounded-lg border border-gray-200 p-6">
                <div className="flex justify-between items-start mb-6">
                    <div className="flex items-center gap-4">
                        <div className="w-16 h-16 bg-indigo-100 rounded-lg flex items-center justify-center">
                            <Package className="w-8 h-8 text-indigo-600" />
                        </div>
                        <div>
                            <h3 className="text-2xl font-bold text-gray-900">{product.name}</h3>
                            <p className="text-gray-500">Code: {product.code}</p>
                        </div>
                    </div>
                    <button
                        onClick={() => onEdit(product)}
                        className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition flex items-center gap-2"
                    >
                        <Edit2 className="w-4 h-4" />
                        Edit Product
                    </button>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <h4 className="text-sm font-medium text-gray-500 mb-2">Company</h4>
                        <div className="flex items-center gap-2">
                            <Building2 className="w-5 h-5 text-gray-400" />
                            <p className="text-gray-900">{company?.name || 'Unknown'}</p>
                        </div>
                    </div>

                    <div>
                        <h4 className="text-sm font-medium text-gray-500 mb-2">Product Type</h4>
                        <span className={`px-3 py-1 text-sm rounded-full ${
                            product.type === 'INSURANCE' ? 'bg-blue-100 text-blue-800' :
                                product.type === 'INVESTMENT' ? 'bg-green-100 text-green-800' :
                                    product.type === 'LOAN' ? 'bg-purple-100 text-purple-800' :
                                        'bg-yellow-100 text-yellow-800'
                        }`}>
                            {product.type}
                        </span>
                    </div>

                    <div>
                        <h4 className="text-sm font-medium text-gray-500 mb-2">Amount Range</h4>
                        <div className="flex items-center gap-2">
                            <DollarSign className="w-5 h-5 text-gray-400" />
                            <p className="text-gray-900">
                                {formatCurrency(product.minAmount)} - {formatCurrency(product.maxAmount)}
                            </p>
                        </div>
                    </div>

                    <div>
                        <h4 className="text-sm font-medium text-gray-500 mb-2">Status</h4>
                        <span className={`px-3 py-1 text-sm rounded-full ${
                            product.active
                                ? 'bg-green-100 text-green-800'
                                : 'bg-gray-100 text-gray-800'
                        }`}>
                            {product.active ? 'Active' : 'Inactive'}
                        </span>
                    </div>

                    {product.description && (
                        <div className="md:col-span-2">
                            <h4 className="text-sm font-medium text-gray-500 mb-2">Description</h4>
                            <p className="text-gray-900">{product.description}</p>
                        </div>
                    )}

                    <div className="md:col-span-2 pt-4 border-t border-gray-200">
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                            <div>
                                <p className="text-gray-500">Created</p>
                                <p className="text-gray-900">
                                    {product.createdAt ? new Date(product.createdAt).toLocaleDateString() : 'N/A'}
                                </p>
                            </div>
                            <div>
                                <p className="text-gray-500">Last Updated</p>
                                <p className="text-gray-900">
                                    {product.updatedAt ? new Date(product.updatedAt).toLocaleDateString() : 'N/A'}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductDetailsView;
